import { Component, OnInit } from '@angular/core';

import * as _ from 'lodash';

import { Dialog, DialogRef, DialogParams, DialogStringFunction } from '../../../dialog/dialog.base';

/**
 * @ignore
 */
@Component({
  selector: 'uex-dialog-loading',
  templateUrl: './loading.component.html'
})
export class DialogLoadingComponent implements OnInit {
  constructor(
    private _dialogRef: DialogRef,
    private _dialogParams: DialogParams
  ) {
    this.dialog = this._dialogRef.dialog;
  }

  public dialog: Dialog;

  public get message(): string {
    let message: DialogStringFunction | string = this._dialogParams.get('message');
    if(_.isFunction(message)) {
      message = (<DialogStringFunction>message)();
    }
    return message ? (<string>message) : 'Carregando...';
  }

  public get color(): string {
    return this._dialogParams.get('color') || 'primary';
  }

  ngOnInit() { }
}
